import styled from "styled-components";
import { LOGO_LG } from "@assets";
import {
  Form as AntForm,
  Divider as AntDivider,
  Input as AntInput,
} from "antd";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    rgba(74, 14, 68, 1) 15%,
    rgba(30, 23, 47, 1) 60%
  );
  padding: 0px 29px;

  .ant-btn-primary {
    margin-top: 8px;
    width: 100%;
    height: 52px;
    border-radius: 10px !important;
  }

  #register-btn {
    margin-bottom: 30px;
  }
`;

export const SkipLink = styled.div`
  width: 100%;
  padding-top: 30px;
  text-align: right;
  font-size: 14px;
  font-weight: 500;
  color: #d69c17;
  cursor: pointer;
`;

export const Logo = styled.img.attrs({
  alt: "logo",
  src: LOGO_LG,
})`
  width: 180px;
  height: auto;
  object-fit: contain;
  padding-top: 25px;
`;

export const Form = styled(AntForm)`
  margin-top: 30px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-label {
    text-align: center;
  }

  .ant-form-item-label label {
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  input {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;
    text-align: center;
  }
`;

export const BottomText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
`;

export const Divider = styled(AntDivider)`
  margin: 40px 0 !important;

  .ant-divider-inner-text {
    font-size: 18px;
    font-weight: normal;
    color: #ffffff;
  }

  ::before,
  ::after {
    border: 1px solid #e1cce0;
    border-color: #e1cce0 !important;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const GoogleLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const TelegramLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  align-items: center;
  flex-direction: row;
  @media (max-width: 450px) {
    flex-direction: column;
    gap: 10px;
  }
`;
